const Home = () => {
    return (
        <div>
            <h2>Welcome to the Ether BackOffice</h2>
        </div>
    );
};

export default Home;
